import InitApi from "api/InitApi";
import useTokenStore from "store/tokenStore";
import { useMutation } from "react-query";
import toast from "react-hot-toast";
import ServerErrors from "components/SeverErrors";

const usePublishRoles = () => {
	const { accessToken } = useTokenStore();

	const save = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.post("/publish-roles");
		return res.data;
	};

	return useMutation(save, {
		onSuccess: async (data) => {
			toast.success(data?.message);
		},
		onError: async (error) => {
			const errorMessage =
				error?.response?.data?.message || "Error publishing roles";
			toast.error(<ServerErrors errorMessage={errorMessage} />, {
				className: "max-w-max",
			});
		},
	});
};

export default usePublishRoles;
